<template>
    <div class="section-map">
        <block-map class="section-map__map" :progresses="progresses" />

        <transition name="fade-fake">
            <block-event v-if="fakeEvents" class="section-map__event-fake section-map__event-fake--1" :id="1" />
        </transition>
        <transition name="fade-fake">
            <block-event v-if="fakeEvents" class="section-map__event-fake section-map__event-fake--2" :id="2" />
        </transition>
        <transition name="fade-fake">
            <block-event v-if="fakeEvents" class="section-map__event-fake section-map__event-fake--3" :id="3" />
        </transition>

        <div class="section-map__regions" v-if="!hideEvents">
            <div v-for="region in regions" :key="region.id">
                <transition name="event">
                    <div class="section-map__event" :id="enemyByRegion(region.id).id" v-if="enemyByRegion(region.id)" :style="getPosition(enemyByRegion(region.id).place)">
                        <block-event
                            :id="0"
                            @click="onClickProblem(enemyByRegion(region.id))"
                        />
                    </div>
                </transition>

                <transition name="event">
                    <div class="section-map__event" :id="actionByRegion(region.id).id" v-if="actionByRegion(region.id)" :style="getPosition(actionByRegion(region.id).place)">
                        <block-event
                            show-timeout
                            :id="actionByRegion(region.id).config.id"
                            :timeout="actionByRegion(region.id).waitTo"
                            @click="onSelectAction(actionByRegion(region.id))"
                        />
                    </div>
                </transition>
            </div>
        </div>

        <ui-popup ref="popup" hide-close :close-on-esc="false" :click-outside-to-close="false">
            <block-action
                v-if="activeAction"
                :id="activeAction.id"
                :config="activeAction.config"
                :data="activeAction.data"
                :region-id="activeAction.region"
                @close="onCloseAction"
            />
        </ui-popup>

        <core-portal target=".game">
            <transition name="fade">
                <ui-overlay
                    v-if="hint"
                    class="section-map__overlay"
                    :rects="hint"
                />
            </transition>
        </core-portal>

        <core-portal target=".game">
            <transition name="fade">
                <div class="section-map__hint" v-if="hint" :style="{left: (hint[0].left + 110) + 'px', top: hint[0].top + 25 + 'px'}">
                    <template v-if="hintId === 0">Кликните, чтобы остановить влияние конкурента в регионе</template>
                    <template v-if="hintId === 1">Отправьте заказ</template>
                    <template v-if="hintId === 2">Ответьте на вопрос покупателя</template>
                    <template v-if="hintId === 3">Попросите покупателя оставить отзыв</template>
                    <template v-if="hintId === 4">Ответьте на негативный отзыв клиента</template>
                </div>
            </transition>
        </core-portal>

        <core-portal target=".game">
            <div>
                <span
                    class="section-map__hint-action"
                    v-for="item in hint"
                    :key="item.key"
                    :style="{width: item.width + 'px', height: item.height + 'px', top: item.top + 'px', left: item.left + 'px'}"
                    @click="onClickHint"
                ></span>
            </div>
        </core-portal>
    </div>
</template>

<script>
    import { mapState, mapGetters, mapActions } from 'vuex'
    import CorePortal from '@/components/core/portal'

    export default {
        components: {
            CorePortal
        },
        props: {
            hideEvents: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                fakeEvents: false,
                timeout: null,
                activeAction: null,
                hint: null,
                hintId: null,
                hintAction: null,
                hintUsed: []
            }
        },
        computed: {
            ...mapState('regions', ['regions']),
            ...mapGetters('actions', ['actionByRegion', 'availableActions']),
            ...mapGetters('enemy', ['enemyByRegion']),
            ...mapState('enemy', ['enemies']),
            ...mapState('guide', ['step']),

            progresses () {
                return this.regions.reduce((result, item) => {
                    result[item.id] = item.progress
                    return result
                }, {})
            }
        },

        methods: {
            ...mapActions('enemy', ['removeEnemy']),
            ...mapActions('control', ['pause', 'start']),

            onSelectAction (action) {
                this.activeAction = action
                this.$refs.popup.open()
                clearTimeout(this.timeout)
            },

            onClickProblem (problem) {
                this.removeEnemy(problem.id)
            },

            onCloseAction () {
                this.$refs.popup.close()
                this.timeout = setTimeout(() => {
                    this.activeAction = null
                }, 2000)
            },

            onClickHint () {
                this.start()
                this.hint = null
                setTimeout(() => {
                    if (this.hintId === 0) {
                        this.onClickProblem(this.hintAction)
                    } else {
                        this.onSelectAction(this.hintAction)
                    }
                }, 400)
            },

            getPosition (place) {
                return {
                    top: place.top + '%',
                    left: place.left + '%'
                }
            },
            checkHint (hint) {
                if (this.hintUsed.indexOf(hint.data.id) === -1) {
                    this.hintUsed.push(hint.data.id)
                    setTimeout(() => {
                        const rectGame = document.querySelector('.game').getBoundingClientRect()
                        const rectAction = document.getElementById(hint.id).getBoundingClientRect()
                        const padding = 20
                        this.hintId = hint.data.id
                        this.hintAction = hint
                        this.hint = [{
                            key: hint.id,
                            width: rectAction.width + padding + padding,
                            height: rectAction.height + padding + padding,
                            top: rectAction.top - rectGame.top - padding,
                            left: rectAction.left - rectGame.left - padding,
                            rx: 100,
                            ry: 100
                        }]
                        this.pause()
                    }, 600)
                }
            }
        },

        watch: {
            step (step) {
                if (step.name === 'events') {
                    this.fakeEvents = true
                } else {
                    this.fakeEvents = false
                }
            },
            availableActions (actions = []) {
                actions.forEach(action => {
                    this.checkHint(action)
                })
            },
            enemies (actions = []) {
                actions.forEach(action => {
                    this.checkHint(action)
                })
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .section-map {
        position relative
        margin 0 2rem

        +layout-xs() {
            margin 0
        }

        &__regions {
            position absolute
            top 0
            left 0
            right 0
            bottom 0
            z-index 11
        }

        &__overlay {
            position absolute!important
            z-index 300!important
        }

        &__event {
            position absolute
            z-index 10
            margin-left -3.3rem
            margin-top @margin-left

            +layout-md() {
                margin-left -2.7rem
                margin-top @margin-left
            }
        }

        &__event-fake {
            position absolute
            z-index 10
            transform scale(1.2)
            +layout-sm() {
                transform scale(1)
            }

            &--1 {
                top 0.7rem
                right 14rem
                +layout-sm() {
                    top 5.7rem
                    right auto
                    left 40%
                }
            }
            &--2 {
                top 1rem
                left 9.7rem
                +layout-sm() {
                    top 0
                    left 56%
                }
            }
            &--3 {
                top 16.2rem
                left 13.6rem
                +layout-sm() {
                    top 4.2rem
                    left 10%
                }
            }
        }

        &__hint-action {
            position absolute
            z-index 302
            border-radius 50%
            cursor pointer
        }

        &__hint {
            position absolute
            width 26rem
            z-index 301
            color #fff
            +layout-sm() {
                left 2rem!important
                right 2rem!important
                width auto!important
                margin-top 8rem
            }
        }
    }

    .event-enter-active {
        transition opacity 0.4s ease, transform 0.4s cubic-bezier(0.82, 0.28, 0.27, 1.63)
    }
    .event-leave-active {
        transition opacity 0.3s ease, transform 0.3s ease
    }
    .event-leave-to,
    .event-enter {
        opacity 0
        transform scale(0)
    }

    .fade-fake-enter-active,
    .fade-fake-leave-active {
        transition opacity 0.3s ease, transform 0.3s ease
    }

    .fade-fake-enter,
    .fade-fake-leave-to {
        opacity 0
    }


    .fade-enter-active,
    .fade-leave-active {
        transition opacity 0.6s ease
    }

    .fade-enter,
    .fade-leave-to {
        opacity 0
    }
</style>
